import { IRoute } from "src/pages/Router/routes";
import InvoiceDetailsPage from "src/pages/Admin/Accounting/InvoiceDetailsPage";
import InvoiceCheckoutPage from "src/pages/Admin/Accounting/InvoiceCheckoutPage";
import TransactionDetailsPage from "src/pages/Admin/Accounting/TransactionDetailsPage";

import CustomerMain from "..";

// Nested routes for invoice/transaction details
export const CustomerAccountingNested: IRoute[] = [
  // Invoice details - customer route
  {
    exact: true,
    path: "/accounting/invoices/:invoiceId",
    pageComponent: InvoiceDetailsPage,
    title: "Invoice Details",
    menuType: "EMPTY",
    privateRoute: true,
    parent: CustomerMain[ 0 ],
    modules: [ "accounting" ],
    roles: [ "customer", "admin" ],
    canView: store => {
      return !!store.users.user?.role?.permissions.find(p => p.code === "view-transaction") || !!store.global.masqueradeMode?.active;
    }
  },
  // Invoice checkout - customer route
  {
    exact: true,
    path: "/accounting/invoices/:invoiceId/checkout",
    pageComponent: InvoiceCheckoutPage,
    title: "Invoice Checkout",
    menuType: "MAIN",
    privateRoute: true,
    hidden: true,
    modules: [ "accounting", "payment" ],
    roles: [ "customer" ],
    canView: store => {
      return !!store.users.user?.role?.permissions.find(p => p.code === "view-invoice") || !!store.global.masqueradeMode?.active;
    }
  },
  // Transaction details - customer route
  {
    exact: true,
    path: "/accounting/transactions/:transactionId",
    pageComponent: TransactionDetailsPage,
    title: "Transaction Details",
    menuType: "MAIN",
    privateRoute: true,
    hidden: true,
    modules: [ "accounting" ],
    roles: [ "customer", "admin" ],
    canView: store => {
      return !!store.users.user?.role?.permissions.find(p => p.code === "view-transaction") || !!store.global.masqueradeMode?.active;
    }
  }
];

export default [ ...CustomerAccountingNested ];
